import { render, staticRenderFns } from "./QuickLoginButton.vue?vue&type=template&id=05c38e3d&scoped=true&"
import script from "./QuickLoginButton.vue?vue&type=script&lang=ts&"
export * from "./QuickLoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./QuickLoginButton.vue?vue&type=style&index=0&id=05c38e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c38e3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
